<script lang="ts">
  export let strokeColor: string;
  let clazz = '';
  export { clazz as class };
</script>

<span style="--stroke-color: {strokeColor}" class="{clazz} ubar-stroke"><slot /></span>

<style lang="postcss">
  .ubar-stroke {
    color: white;
    text-shadow: -1px -1px 0 var(--stroke-color, #fff), 1px -1px 0 var(--stroke-color, #fff),
      -1px 1px 0 var(--stroke-color, #fff), 1px 1px 0 var(--stroke-color, #fff);
  }
</style>
